import { render, staticRenderFns } from "./FilteredResultsDashboard.vue?vue&type=template&id=0fc2cba9&scoped=true&lang=pug"
import script from "./FilteredResultsDashboard.vue?vue&type=script&lang=js"
export * from "./FilteredResultsDashboard.vue?vue&type=script&lang=js"
import style0 from "./FilteredResultsDashboard.vue?vue&type=style&index=0&id=0fc2cba9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc2cba9",
  null
  
)

export default component.exports